<div class="w-full h-full max-h-full min-h-0">
    <!-- Book/Focus buttons -->
    <div class="flex flex-row items-center justify-center w-full pb-4 gap-0.5 relative">
        @if (showFocusNowForm) {
            <div class="h-12 w-full flex items-center justify-between">
                <div class="mr-auto text-bluegrey text-16 font-semibold font-inter">Focus now</div>

                <p-button
                    severity="secondary"
                    [outlined]="true"
                    (click)="showFocusNowForm = false"
                    icon="pi pi-times"
                    styleClass="aspect-square"
                    size="small" />
            </div>
        } @else if (showScheduleForm) {
            <div class="h-12 w-full flex items-center justify-between">
                <div class="mr-auto text-bluegrey text-16 font-semibold font-inter"
                    >Schedule session</div
                >
                <p-button
                    severity="secondary"
                    [outlined]="true"
                    (click)="showScheduleForm = false"
                    icon="pi pi-times"
                    styleClass="aspect-square"
                    size="small" />
            </div>
        } @else {
            <p-button
                severity="primary"
                size="large"
                label="Focus now"
                class="w-full"
                classes="w-full"
                styleClass="!h-[48px] w-full !rounded-r-none"
                (click)="showFocusNowForm = !showFocusNowForm; showScheduleForm = false"></p-button>

            <p-button
                severity="primary"
                size="large"
                icon="pi pi-clock"
                styleClass="!w-[48px] aspect-square !rounded-l-none"
                (click)="showScheduleForm = !showScheduleForm; showFocusNowForm = false" />
        }

        <div
            class="h-[1px] border border-latte absolute bottom-0 w-[calc(100%_+_32px)] -left-4"></div>
    </div>
    <div class="w-full mt-4">
        @if (!showFocusNowForm) {
            <div class="w-full">
                <fm-booking-hub-session-settings />
            </div>
        }

        @if (showScheduleForm) {
            <div class="w-full pt-4 mt-4">
                <fm-booking-hub-schedule-form />
            </div>
        }
        @if (showFocusNowForm) {
            <div class="w-full mt-2">
                <fm-now-sessions-sidebar />
            </div>
        }
    </div>
</div>
